import React, { createContext, useContext, useEffect, useState } from "react";
import { useAdminContext } from "./AdminContext";
import { Get_User_Details } from "../DAL/Login/Auth";
const SidebarStatusContext = createContext();
const RoleContext = createContext();
const UserDataContext = createContext();
export const ProfileImageContext = createContext();
export const useSidebarStatus = () => useContext(SidebarStatusContext);
export const useRole = () => useContext(RoleContext);
export const useUserData = () => useContext(UserDataContext);
export const AppProvider = ({ children }) => {
  const { socket } = useAdminContext();
  const [profileImage, setProfileImage] = useState(null);
  const [userData, setUserData] = useState(null);
  const [newNotification, setNewNotification] = useState(null);
  const [unreadMessageCount, setUnreadMessageCount] = useState(0);
  const [isNewMessage, setisNewMessage] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState(null);

  useEffect(() => {}, [newNotification]);

  const updateData = (data) => {
    setUserData(data.employee_data);
  };

  useEffect(() => {
    if (!socket) return;

    const handleCaseEvent = (data) => {
      setNewNotification((prev) => [data, ...(prev || [])]);
    };

    socket?.on("support_ticket_receiver", handleCaseEvent);
    socket?.on("cancel_subscription_receiver", handleCaseEvent);
    socket?.on("ad_account_receiver", handleCaseEvent);
    socket?.on("affiliate_payout_receiver", handleCaseEvent);
    socket?.on("clear_funds_receiver", handleCaseEvent);
    socket?.on("appeal_account_receiver", handleCaseEvent);
    socket?.on("account_topup_receiver", handleCaseEvent);
    socket?.on("wallet_deposit_receiver", handleCaseEvent);
    return () => {
      socket.off("support_ticket_receiver", handleCaseEvent);
      socket.off("cancel_subscription_receiver", handleCaseEvent);
      socket.off("ad_account_receiver", handleCaseEvent);
      socket.off("affiliate_payout_receiver", handleCaseEvent);
      socket.off("clear_funds_receiver", handleCaseEvent);
      socket.off("appeal_account_receiver", handleCaseEvent);
      socket.off("wallet_deposit_receiver", handleCaseEvent);
      socket.off("account_topup_receiver", handleCaseEvent);
    };
  }, [socket]);

  // Getting details of the user this is the api function used to set details of the admin in the context
  const getUserData = async () => {
    const response = await Get_User_Details();
    if (response.code === 200) {
      setUnreadMessageCount(response.total_unread_meassage_count);
    }
  };

  useEffect(() => {
    console.log("unreadMessageCount ================>", unreadMessageCount);
    if (unreadMessageCount < 0) {
      getUserData();
    }
  }, [unreadMessageCount]);

  return (
    //     <PrivilegesContext.Provider value={{ privileges, setPrivileges }}>
    <SidebarStatusContext.Provider value={{ updateData }}>
      <RoleContext.Provider>
        <UserDataContext.Provider
          value={{
            userData,
            setUserData,
            newNotification,
            setNewNotification,
            setUnreadMessageCount,
            unreadMessageCount,
            setisNewMessage,
            isNewMessage,
            setNotificationMessage,
            notificationMessage,
          }}
        >
          <ProfileImageContext.Provider
            value={{ profileImage, setProfileImage }}
          >
            {children}
          </ProfileImageContext.Provider>
        </UserDataContext.Provider>
      </RoleContext.Provider>
    </SidebarStatusContext.Provider>
    //     </PrivilegesContext.Provider>
  );
};
